import React, {useEffect} from 'react';
import { Slider } from '@material-ui/core';

import { Container } from './styles';

export type MarkType = {
  value: number;
  label: string;
}

export type RangeSliderProps = {
  minValue: number;
  maxValue: number;
  step: number;
  marks?: MarkType[];
  initialValue: number | number[];
  handleChange: (value: number | number[]) => void;
  displayLabel?: 'auto' | 'on' | 'off';
}

export const RangeSlider = ({
  minValue, 
  maxValue, 
  step, 
  marks, 
  initialValue, 
  handleChange, 
  displayLabel = "off", 
}: RangeSliderProps) => {

  const [value, setValue] = React.useState<number | number[]>(initialValue);

  const handleSliderChange = (event: any, newValue: number | number[]) => {
    setValue(newValue as number[]);
  };

  useEffect(() => {
    handleChange(value);
  }, [handleChange, value])

  return <Container >
    <Slider
      value={value}
      onChange={handleSliderChange}
      valueLabelDisplay={displayLabel}
      marks={marks && marks}
      min={minValue}
      max={maxValue}
      step={step}
    />
  </Container>
}